import {
  TWO_FACTOR_PASSWORD_ERRORS,
  TWO_FACTOR_PASSWORD_LOCKOUT_DEFAULT_SEC,
  TWO_FACTOR_PASSWORD_MAX_ATTEMPTS,
} from '../constants/twoFactorMessages';
import {
  clearTwoFactorPasswordLockout,
  getTwoFactorPasswordLockout,
  saveTwoFactorPasswordLockout,
} from './twoFactorPasswordLockout';
import {
  readPersistedJson,
  removePersistedKey,
  writePersistedJson,
} from './twoFactorPersistedStorage';

const STORAGE_PREFIX = 'mhd:2fa-pwd-attempts:';

const attemptsKey = userId => `${STORAGE_PREFIX}${userId}`;

export const getPasswordFailedAttemptCount = userId => {
  if (!userId) {
    return 0;
  }

  const parsed = readPersistedJson(attemptsKey(userId));
  return parsed && parsed.count ? parsed.count : 0;
};

export const incrementPasswordFailedAttempt = userId => {
  if (!userId) {
    return {count: 0, lockout: null};
  }

  const count = getPasswordFailedAttemptCount(userId) + 1;
  writePersistedJson(attemptsKey(userId), {count});

  let lockout = null;
  if (count >= TWO_FACTOR_PASSWORD_MAX_ATTEMPTS) {
    saveTwoFactorPasswordLockout(
      userId,
      TWO_FACTOR_PASSWORD_LOCKOUT_DEFAULT_SEC,
      TWO_FACTOR_PASSWORD_ERRORS.LOCKOUT,
    );
    lockout = getTwoFactorPasswordLockout(userId);
  }

  return {count, lockout};
};

export const syncPasswordAttemptsOnServerLockout = userId => {
  if (!userId) {
    return;
  }

  writePersistedJson(attemptsKey(userId), {count: TWO_FACTOR_PASSWORD_MAX_ATTEMPTS});
};

export const clearPasswordFailedAttempts = userId => {
  if (!userId) {
    return;
  }

  removePersistedKey(attemptsKey(userId));
};

export const resetStalePasswordAttemptsAfterExpiredLockout = userId => {
  if (!userId) {
    return;
  }

  if (
    getPasswordFailedAttemptCount(userId) >= TWO_FACTOR_PASSWORD_MAX_ATTEMPTS &&
    !getTwoFactorPasswordLockout(userId)
  ) {
    clearPasswordFailedAttempts(userId);
  }
};

export const resetPasswordAttemptsAfterLockoutExpired = userId => {
  if (!userId) {
    return;
  }

  clearTwoFactorPasswordLockout(userId);
  clearPasswordFailedAttempts(userId);
};

export const clearAllPasswordAttemptState = userId => {
  if (!userId) {
    return;
  }

  clearTwoFactorPasswordLockout(userId);
  clearPasswordFailedAttempts(userId);
};



// WEBPACK FOOTER //
// ./src/helpers/twoFactorPasswordAttempts.js